import StatusBadge from './StatusBadge';
import CoreBadge from './CoreBadge';
import usePaginacao from '../../hooks/usePaginacao';
import { formatDateOnly } from '../../utils/date';
import { onKeyActivate } from '../../utils/teclado';

// Tabela compartilhada pelas telas de Vencimentos/Corretivas — por hospital e no portfólio
// inteiro (Dashboard). `mostrarHospital` liga a coluna extra de hospital (visão de portfólio);
// `onSelecionar(item)` é opcional — se omitido, a linha não é clicável (ex: hospital sem
// callback de navegação até o requisito).
export default function TabelaPrazos({ itens, campoData, colunaData, vazioTexto, mostrarHospital = false, onSelecionar }) {
  const { paginados, Paginacao } = usePaginacao(itens, 20);

  if (itens.length === 0) {
    return (
      <div className="card-soft" style={{ padding: 24 }}>
        <div className="empty-state">
          <div className="ms">event_available</div>
          <div>{vazioTexto}</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="card-soft" style={{ padding: 24 }}>
        <div className="am-table-wrap">
          <table className="am-table">
            <thead>
              <tr>
                {mostrarHospital && <th>Hospital</th>}
                <th>Requisito</th>
                <th>Status atual</th>
                <th>{colunaData}</th>
                <th>Situação</th>
              </tr>
            </thead>
            <tbody>
              {paginados.map((v) => (
                <tr
                  key={mostrarHospital ? `${v.idHospital}-${v.id_requisito}` : v.id_requisito}
                  role={onSelecionar ? 'button' : undefined}
                  tabIndex={onSelecionar ? 0 : undefined}
                  onClick={onSelecionar ? () => onSelecionar(v) : undefined}
                  onKeyDown={onSelecionar ? onKeyActivate(() => onSelecionar(v)) : undefined}
                >
                  {mostrarHospital && <td style={{ fontWeight: 600 }}>{v.nomeHospital}</td>}
                  <td style={{ maxWidth: mostrarHospital ? 360 : 420 }}>
                    <div title={v.texto_requisito}>
                      <span className="d-inline-flex align-items-center gap-1">
                        <strong>{v.codigo_requisito}</strong>
                        {v.core && <CoreBadge />}
                      </span>{' '}
                      — {v.texto_requisito}
                    </div>
                    {v.fragilidade && (
                      <div style={{ fontSize: 12, color: 'var(--am-critico)', marginTop: 4 }}>
                        <strong>Fragilidade:</strong> {v.fragilidade}
                      </div>
                    )}
                    {v.acao_proposta && (
                      <div style={{ fontSize: 12, color: 'var(--am-cinza-texto-2)', marginTop: 2 }}>
                        <strong>Ação proposta:</strong> {v.acao_proposta}
                      </div>
                    )}
                  </td>
                  <td>
                    <StatusBadge status={v.status} />
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>{formatDateOnly(v[campoData])}</td>
                  <td>
                    <StatusBadge status={v._statusJanela} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Paginacao />
    </>
  );
}
